import { POPULAR_OFFERS_VIEW } from './types';

export const triggerPopularOffersIsViewed = (offersToDisplay, offersLength) => ({
  type: POPULAR_OFFERS_VIEW,
  offersToDisplay,
  offersLength,
});
